<div [className]="theme.root">
  <div class="container overflow-auto {{ theme.container }}">
    <div class="py-v-spacing sm:px-v-spacing max-w-container mx-auto {{ alignment }} table">
      <vision-button defaultStyle="primary" [data]="buttonData"></vision-button>
    </div>
  </div>
</div>
